import _default from './Table';
export { _default as default };